<template>
	<div class="job-title">
		<div class="row" style="margin-bottom: 20px;">
			<div class="col-xl-6">职称管理</div>
			<div class="col-xl-6" style="display: flex;justify-content: flex-end;align-items: center;"><Breadcrumb></Breadcrumb></div>
		</div>

		<el-card>
			<div class="btn-wrap" style="margin-bottom: 20px;"><el-button type="primary" @click="openJobTitleDialog('add')">新增</el-button></div>
			<el-table :data="jobTitleTableData" border style="width: 100%">
				<!-- <el-table-column prop="id" label="id" width="180"></el-table-column> -->
				<el-table-column prop="name" label="职称"></el-table-column>
				<el-table-column label="操作">
					<template slot-scope="scope">
						<el-button style="margin-right: 20px;" type="primary" @click="openJobTitleDialog('edit', scope.row)">修改</el-button>
						<el-popconfirm title="确定删除吗？" @confirm="confirmDel(scope.row.id)"><el-button slot="reference" type="danger">删除</el-button></el-popconfirm>
					</template>
				</el-table-column>
			</el-table>
		</el-card>

		<!-- 新增或者修改职称 -->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="30%">
			<el-input placeholder="请输入内容" v-model="form.dictName" clearable></el-input>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogCancel">取 消</el-button>
				<el-button type="primary" @click="confire">确 定</el-button>
			</span>
		</el-dialog>
	</div>
</template>

<script>
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import { getPlatformInformationData, addPlatformInformationData, delPlatformInformationData, editPlatformInformationData } from '@/api/after/systemManagement.js';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			dialogTitle: '新增',
			dialogVisible: false,
			form: {
				dictName: '',
				dictTypeId: 7,
				parentId:0,
				level:1,
			},
			curEditDataId: 0,
			jobTitleTableData: [
				{
					id: 1,
					name: '老师'
				}
			]
		};
	},
	created() {
		this.getPlatformInformationData();
	},
	methods: {
		// 获取职称列表
		async getPlatformInformationData() {
			const res = await getPlatformInformationData(7);
			console.log('职称列表', res);
			if (res.code == 200) {
				this.jobTitleTableData = res.data;
			} else {
				this.$message.error(res.data);
			}
		},
		// 添加职称
		async addPlatformInformationData() {
			const res = await addPlatformInformationData(this.form);
			if (res.code == 200) {
				await this.getPlatformInformationData();
				this.dialogVisible = false;
			} else {
				this.$message.error(res.data);
			}
		},
		// 修改职称
		async editPlatformInformationData() {
			let params = {
				...this.form,
				id: this.curEditDataId
			};
			const res = await editPlatformInformationData(params);
			if (res.code == 200) {
				this.dialogVisible = false;
				this.form.dictName = '';
				this.getPlatformInformationData();
			} else {
				this.$message.error(res.data);
			}
		},
		// 删除职称
		async delPlatformInformationData(id) {
			const res = await delPlatformInformationData(id);
			if (res.code == 200) {
				this.getPlatformInformationData()
			} else {
				this.$message.error(res.msg);
			}
		},
		// 确认删除
		async confirmDel(id) {
			await this.delPlatformInformationData(id);
		},
		// 确定弹出框
		confire() {
			if (this.dialogTitle === '新增') {
				this.addPlatformInformationData();
			} else {
				this.editPlatformInformationData();
			}
		},
		// 打开弹出框
		openJobTitleDialog(type, data) {
			if (type === 'add') {
				this.dialogTitle = '新增';
			} else {
				this.dialogTitle = '修改';
				this.curEditDataId = data.id;
				this.form.dictName = data.name;
			}
			this.dialogVisible = true;
		},
		// 取消对话框
		dialogCancel() {
			this.dialogVisible = false;
			this.form.dictName = '';
		}
	}
};
</script>

<style scoped></style>
